
export default function DateFormatter(value) {
	try {

		const dateString = value;
		const date = new Date(dateString);

		const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
		const month = months[date.getMonth()];
		const day = date.getDate();
		const year = date.getFullYear();

		const hours = date.getHours();
		const minutes = date.getMinutes();
		const seconds = date.getSeconds();

		const time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

		return `${month} ${day}, ${year} ${time}`;

	} catch (e) {
		
	}
}

export function getDate(normalDate) {
	console.log(normalDate, "normalDate");
	const date = new Date(normalDate);
  
	const options = {
	  day: "2-digit",
	  month: "short",
	  year: "numeric",
	  hour: "2-digit",
	  minute: "2-digit",
	  hour12: true,
	};
  
	return date.toLocaleString("en-GB", options);
  }
  